<template>
  <div class="card-document">
    <div class="d-flex justify-content-end">
      <b-dropdown
        size="lg"
        variant="link"
        toggle-class="text-decoration-none"
        no-caret
      >
        <template #button-content>
          <img src="@/assets/images/icons/icon-point.svg" alt="" />
        </template>
        <!-- <b-dropdown-item @click.prevent="viewDocument()">Ver</b-dropdown-item> -->
        <b-dropdown-item @click.prevent="downloadDocument()"
          >Descargar</b-dropdown-item
        >
        <b-dropdown-item @click.prevent="deleteDocument()"
          >Eliminar</b-dropdown-item
        >
      </b-dropdown>
    </div>
    <div class="d-flex justify-content-center flex-column align-items-center">
      <div>
        <img src="@/assets/images/icons/icon-list-document.svg" alt="" />
      </div>
      <div class="mt-2 line-clamp-2" :id="`tooltip-document-${item?.id}`">
        {{ item?.original_name }}
      </div>
      <div class="mt-2">
        {{  item?.created_at }}
      </div>
      <b-tooltip
        :target="`tooltip-document-${item?.id}`"
        placement="top"
        custom-class="custom-tooltip-ht"
      >
        {{ item?.original_name }}
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import processSevices from "@/services/legal/service.js";

export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  methods: {
    viewDocument() {
      const me = this;
      window.open(me.item?.path, "_blank");
    },
    async downloadDocument() {
      const me = this;
      try {
        const { data } = await processSevices.downloadFile(me.item?.id);
        const a = document.createElement("a");
        a.href = data?.download_url;
        a.click();
      } catch (error) {
        console.log(error);
      }
    },
    deleteDocument() {
      const me = this;
      me.$emit("deleteDocument", me.item);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-document {
  border: 1px solid #828789;
  border-radius: 4px;
  padding: 8px;
  width: 180px;
  text-align: center;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-wrap: break-word; /* Permite romper palabras largas */
  overflow-wrap: anywhere;
}
</style>
